import routes from '@/config/routes';
import { v3Get, v3Post } from '@/api/axios.instance.V3';
import type {
  IGigPermissionAndGroupPost,
  IGigPermissionGroupRequest,
  IGigPermissionPermissionRequest,
  IGigPermissionRequest,
} from '@/store/admin/types/types';
import type { AxiosResponse } from 'axios';
import type { ApiResponse } from '../types';

const savePermissionWithGroup = async (permissions: IGigPermissionAndGroupPost): Promise<AxiosResponse> => {
  return await v3Post(
    `${routes.backendUrl.permissionAdmin.setGigPermissionAndGroup}/${permissions.clientId}/gig/${permissions.gigId}/group/set`,
    permissions,
  );
};

const getGigPermission = (request: IGigPermissionRequest): ApiResponse =>
  v3Get(`${routes.backendUrl.permissionAdmin.getGigPermissionList}/${request.clientId}/gig/${request.gigId}/list`);

const getGigPermissionGroup = (request: IGigPermissionRequest): ApiResponse =>
  v3Get(`${routes.backendUrl.permissionAdmin.getGigPermissionGroupList}/${request.clientId}/gig/${request.gigId}/list`);

const getGigPermissionGroupByClientAndPermissionId = (request: IGigPermissionPermissionRequest): ApiResponse =>
  v3Get(
    `${routes.backendUrl.permissionAdmin.permission}/gig/client/${request.clientId}/permission/${request.permissionId}/list`,
  );

const getGigPermissionGroupByClientAndGroupId = (request: IGigPermissionGroupRequest): ApiResponse =>
  v3Get(`${routes.backendUrl.permissionAdmin.permission}/gig/client/${request.clientId}/group/${request.groupId}/list`);

export const gigPermissionAdminApi = {
  savePermissionWithGroup,
  getGigPermission,
  getGigPermissionGroup,
  getGigPermissionGroupByClientAndGroupId,
  getGigPermissionGroupByClientAndPermissionId,
};
